import { useOrgStore } from '@/stores/org-store';
import { apiRequest } from '@/utils/api-request';

export const deleteContextGraph = async (graphId: string): Promise<void> => {
  const orgId = useOrgStore.getState().currentOrg?.orgid;
  if (!orgId) {
    throw new Error('Organization ID is required');
  }

  const response = await apiRequest({
    url: `/context-graphs/${orgId}/${graphId}`,
    method: 'DELETE',
    target: 'platform',
  });

  if (response.detail) {
    throw new Error(response.detail);
  }
};
